/*кнопка прокрутки вверх страницы*/
$(document).ready(function() {
    const upBtn = $('#up-btn-scroll');
    const body = $('body');

    /* появление/скрытие кнопки при скролле */
    function showUpBtn() {
        let scrollTop = $(window).scrollTop();

        if (scrollTop >= 20) {
            body.addClass('show-upBtn');
            upBtn.addClass('show');
        } else {
            upBtn.removeClass('show');
            body.removeClass('show-upBtn');
        }
    }


    if ($('#up-btn-scroll').length) {
        /*только для десктопа*/
        if ($(window).width() > 992) {
            $(window).scroll(function() {
                showUpBtn();
            });
        }
    }

    /* прокрутка в начало страницы при клике на кнопку */
    upBtn.on('click', function(){
        $('body, html').animate({
            scrollTop: 0
        }, 200);
        return false;
    });
});
